/*
 * @Author: 王枫叶
 * @Date: 2020-09-28 16:52:13
 * @LastEditors: 王枫叶
 * @LastEditTime: 2020-12-19 14:39:39
 */
const baseConfig = {
  baseServerUrl: "/api/web/admin",
  //playVideoUrl: 'https://tknk.zahokc.cn/',
  playVideoUrl: "/vid/m3u8/", //视频播放
  imgUrl: "", //图片预览
  downLoadUrl: "", //视频下载
}
if (
  process.env.NODE_ENV === "production" &&
  process.env.VUE_APP_TITLE === "test"
) {
  // baseConfig.baseServerUrl = "https://hlsht.cestalt.com/api/web/admin"
  // baseConfig.baseServerUrl = "http://163.53.216.122:8189/api/web/admin"
} else if (process.env.NODE_ENV === "development") {
  // 测试服
  baseConfig.baseServerUrl = "https://ainyht.cestalt.com/api/web/admin"
  // 正式
  // baseConfig.baseServerUrl = "https://jh7x.ainy789.com/api/web/admin"
} else {
  baseConfig.baseServerUrl = "/api/web/admin"
}
export default baseConfig